import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import SonraiMappingForm from './SonraiMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function SonraiCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "token",
        label: "Api Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SonraiMappingForm}
        />
    )
}

export default forwardRef(SonraiCredentialsForm);